/* cs-request.js - "Modell melden"-Formular (snippets/cs-request-form.liquid)
   per fetch statt Seiten-Reload.

   Vorher (bis 06.09.2026): nativer POST auf /contact, 302, kompletter
   Neu-Render der Startseite samt Konfigurator-Katalog - sekundenlang
   kein Feedback, das "Danke" kam so spaet, dass es wie "nicht
   abgeschickt" wirkte (Pauls Befund). Jetzt:

   1. Klick -> Button sofort in Sende-Zustand (aria-busy, Spinner, Text).
   2. Shopifys Spam-Schutz (captcha-bootstrap + hCaptcha-Provider) faengt
      das submit-Event, holt den Token und ruft danach den nativen
      HTMLFormElement.prototype.submit des Formulars auf (der Provider
      bindet sich diese Referenz beim Binden, das passiert beim ersten
      focusin/change im Formular). Genau dort haengt dieses Script:
      prototype.submit ist fuer #cs-request-form ein fetch(POST) mit dem
      kompletten Formular inkl. h-captcha-response. Ohne Token antwortet
      /contact mit 400 (verifiziert 06.09.) - deshalb KEIN data-nocaptcha
      und kein Fetch am submit-Event vorbei.
   3. Shopify antwortet 302 auf den Referer-PFAD + ?contact_posted=true
      (Query des Referers wird verworfen - beobachtet 06.09. an
      /challenge?return_path=/). Der Referer des fetch ist deshalb die
      leichte Seite /pages/modellanfrage (Template page.cs-modell-ok +
      sections/cs-request-done.liquid, ~0,3 s) statt der Seite selbst
      (Startseite 1-2 s Server-Render): nur response.url zaehlt, der
      Body wird verworfen. Sprachpraefix aus Shopify.routes.root.
      Erfolg -> Formularteile hidden, Erfolgsband aus dem <template> im
      Snippet einsetzen, Fokus darauf. Konfigurator-Zustand bleibt.
   4. /challenge (Shopifys Bot-Pruefung, z. B. wenn hCaptcha den Token
      nicht anerkennt): der Browser navigiert auf genau diese
      Challenge-URL, der Kunde loest sie, Shopify spielt den POST nach
      und landet auf der Landeseite mit serverseitigem Band. KEIN
      erneuter nativer POST: der hCaptcha-Token ist verbraucht, Shopify
      antwortet dann mit der Fehlerseite "Invalid CAPTCHA token"
      (06.09. abends so beobachtet). Netzfehler, Timeout, 400 ->
      Fehlerzeile im Formular, Button wieder frei; der naechste Klick
      holt einen frischen Token.
   5. Ohne Spam-Schutz (kein #captcha-bootstrap) ruft niemand submit():
      dann uebernimmt der submit-Listener den fetch direkt.

   Die submit-Listener in cs-configurator.js / cs-modellfinder.js (Kontext
   nach sessionStorage retten) laufen weiter - harmlos.

   Falle (06.09. abends): display:flex auf .cs-request__submit und
   .cs-request__fields schlug das [hidden]-Default - nach dem Erfolg
   blieben Feld und "Wird gesendet"-Button samt Spinner stehen.
   Guard dafuer in cs-request.css (#cs-request-form [hidden]). */
(function () {
  var form = document.getElementById('cs-request-form');
  if (!form || form.hasAttribute('data-cs-request-ajax')) return;
  if (!window.fetch || !window.FormData || !('content' in document.createElement('template'))) return;
  form.setAttribute('data-cs-request-ajax', '');

  var CTX_KEY = 'cs-request-ctx';
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LIGHT_REFERRER = routeRoot.replace(/\/?$/, '/') + 'pages/modellanfrage';
  var TIMEOUT_MS = 15000;
  var nativeSubmit = HTMLFormElement.prototype.submit;
  var inFlight = false;

  function submitButton() {
    return form.querySelector('.cs-request__submit');
  }

  function setBusy(busy) {
    var btn = submitButton();
    if (!btn) return;
    var label = btn.querySelector('.cs-request__submit-label') || btn;
    if (busy) {
      if (!btn.dataset.idleLabel) btn.dataset.idleLabel = label.textContent;
      btn.setAttribute('aria-busy', 'true');
      /* nicht disabled: der Captcha-Provider liest das Formular und der
         Klick muss als echter submit durchgehen; Doppelklicks faengt
         inFlight. */
      var sending = btn.getAttribute('data-sending-label');
      if (sending) label.textContent = sending;
    } else {
      btn.removeAttribute('aria-busy');
      if (btn.dataset.idleLabel) label.textContent = btn.dataset.idleLabel;
    }
  }

  function errorBox(create) {
    var box = form.querySelector('[data-cs-request-errors]');
    if (!box && create) {
      box = document.createElement('div');
      box.className = 'cs-request__errors';
      box.setAttribute('data-cs-request-errors', '');
      box.setAttribute('role', 'alert');
      box.setAttribute('tabindex', '-1');
      var fields = form.querySelector('.cs-request__fields');
      if (fields && fields.parentNode) fields.parentNode.insertBefore(box, fields);
      else form.appendChild(box);
    }
    return box;
  }

  function showError() {
    inFlight = false;
    setBusy(false);
    var btn = submitButton();
    var msg = btn && btn.getAttribute('data-error-label');
    if (!msg) return;
    var box = errorBox(true);
    box.textContent = msg;
    box.hidden = false;
    box.focus();
  }

  function clearError() {
    var box = errorBox(false);
    if (box) box.hidden = true;
  }

  function showSuccess() {
    inFlight = false;
    setBusy(false);
    var tpl = form.querySelector('template[data-cs-request-success-tpl]');
    var parts = form.querySelectorAll('.cs-request__intro, .cs-request__errors, .cs-request__fields, .cs-request__submit, .cs-request__tip, .cs-request__note');
    for (var i = 0; i < parts.length; i++) parts[i].hidden = true;
    var band = tpl ? tpl.content.firstElementChild.cloneNode(true) : null;
    if (band) {
      var anchor = form.querySelector('.cs-request__intro');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(band, anchor);
      else form.appendChild(band);
      band.focus();
    }
    form.setAttribute('data-cs-request-done', '');
    try { sessionStorage.removeItem(CTX_KEY); } catch (e) {}
  }

  function sendViaFetch() {
    if (inFlight) return;
    inFlight = true;
    setBusy(true);
    clearError();
    var body = new FormData(form);
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS) : null;
    var opts = {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      redirect: 'follow',
      referrer: LIGHT_REFERRER,
      headers: { 'Accept': 'text/html' },
      signal: ctrl ? ctrl.signal : undefined
    };
    fetch(form.getAttribute('action') || '/contact', opts).then(function (res) {
      if (timer) clearTimeout(timer);
      try { if (res.body && res.body.cancel) res.body.cancel(); } catch (e) {}
      var url = res.url || '';
      if (res.ok && url.indexOf('contact_posted=true') !== -1) {
        showSuccess();
        return;
      }
      if (url.indexOf('/challenge') !== -1) {
        window.location.assign(url);
        return;
      }
      showError();
    }).catch(function () {
      if (timer) clearTimeout(timer);
      showError();
    });
  }

  /* Haken fuer den Captcha-Provider: er ruft nach dem Token
     HTMLFormElement.prototype.submit (gebunden an das Formular). Andere
     Formulare laufen unveraendert ueber das Original. */
  try {
    HTMLFormElement.prototype.submit = function () {
      if (this === form && !form.hasAttribute('data-cs-request-done')) {
        sendViaFetch();
        return;
      }
      return nativeSubmit.apply(this, arguments);
    };
  } catch (e) {
    /* Prototyp nicht beschreibbar: bleibt beim nativen Weg */
  }

  form.addEventListener('submit', function (ev) {
    if (form.hasAttribute('data-cs-request-done')) { ev.preventDefault(); return; }
    if (inFlight) { ev.preventDefault(); return; }
    setBusy(true);
    clearError();
    if (!document.getElementById('captcha-bootstrap')) {
      /* Kein Spam-Schutz aktiv: niemand ruft submit() - direkt senden */
      ev.preventDefault();
      sendViaFetch();
    }
    /* sonst: Bootstrap/Provider uebernehmen das Event und rufen nach dem
       Token unseren prototype.submit-Haken */
  });
})();
